import React from "react";

const JNLogo = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 5,
        left: 20,
        background: "#ffffff",
        padding: "8px 12px",
        borderRadius: "8px",
        zIndex: 99,
      }}
    >
      <img
        src="/assets/images/JN_F_Logo.png"
        alt="Logo"
        style={{
          width: "140px",
          height: "50px",
          display: "block",
        }}
      />
    </div>
  );
};

export default JNLogo;
